import { render, staticRenderFns } from "./invitesLog.vue?vue&type=template&id=78d2edb2&"
import script from "./invitesLog.vue?vue&type=script&lang=js&"
export * from "./invitesLog.vue?vue&type=script&lang=js&"
import style0 from "./invitesLog.vue?vue&type=style&index=0&tyle=text%2Fcss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VCol,VDataTable,VRow,VTooltip})
